/**
 * This function will take your string data, the filename, and the file type as arguments,
 * then create a blob from the data and a URL for that blob. This URL will be used as the `href` attribute for a download link.
 */
const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new window.Blob([data], { type: fileType });
  const a = document.createElement("a");
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new window.MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};

export { downloadFile };
